import React, { useContext } from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import LanguageContext from '../../contexts/languageContext';
import MessagesContext from '../../contexts/messagesContext';
import CustomRadio from './CustomRadio';
import AppBar from '../AppBar';
import useCheckMobileScreen from '../../hooks/useWidth';
import { useDispatch, useSelector } from 'react-redux';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import * as type from '../../redux/User/UserType';
import { getRefreshToken } from '../../utils/storage';
import { logout } from '../../redux/User/UserAction';

const styles = makeStyles((theme) => ({
    // container: {
    //     backgroundColor: '#f2f4fa',
    //     padding: '26px 24px',
    //     height: 'calc(100vh - 64px)',
    //     overflow: 'hidden'
    // },
    desktopRadio: {
        // padding:"100px",
        [theme.breakpoints.up(1025)]: {
            width: '500px',
            margin: '50px auto'
        }
    },
    radio: {
        background: '#fff',
        borderRadius: '6px',
        width: '100%',
        marginBottom: '16px',
        marginRight: '0',
        marginLeft: '0',
        '&$checked': {
            background: 'red'
        }
    },
    checked: {},
    radioLabel: {
        '&$checked': {
            backgroundColor: 'red'
        }
    },
    paper: {
        minWidth: '171px',
        borderRadius: '6px',
        display: 'flex',
        justifyContent: (props) => (props.rtl ? 'flex-start' : 'flex-end'),
        padding: '20px 10px 17px 26px',
        direction: 'rtl'
    },
    title: {
        fontFamily: 'mainFont',
        fontSize: '15px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        // lineHeight: '1.69',
        letterSpacing: 'normal',
        textAlign: (props) => (props.rtl ? 'right' : ' left'),
        color: '#232733',
        margin: (props) => (props.rtl ? '0 22px' : '0')
    },
    btn: {
        minWidth: '110px',
        fontSize: '13px',
        color: '#fff',
        whiteSpace: 'nowrap',
        backgroundColor: 'rgba(22 118 204 / 70%)',
        marginLeft: '16px',
        borderRadius: '6px',
        height: '36px'
    },
    btnLabel: {
        justifyContent: 'space-between',
        flexFlow: 'row wrap'
    },
    clinicText: {
        padding: '0 10px'
    },
    menuIcon: {
        margin: '0 4px'
    },
    optionContainer: {},
    optionHeader: {
        color: '#aaa',
        padding: '6px 1em 3px',
        fontWeight: 'bold'
    },
    optionItem: {
        padding: '6px 1em',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#e3e3e3'
        },
        '&:last-child': {
            borderRadius: '6px'
        }
    },
    clinicHeader: ({ hasClinic }) => ({
        fontFamily: 'mainFont',
        fontSize: '18px',
        lineHeight: 1,
        display: hasClinic && 'none'
    }),
    clinicMessage: ({ hasClinic }) => ({
        fontFamily: 'mainFont',
        fontSize: '14px',
        lineHeight: 1.5,
        display: hasClinic && 'none',
        margin: '20px 0'
    }),
    noAccessWrapper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50% ,-50%)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer'
    },
    logout: {
        color: '#416ce1',
        marginTop: '15px'
    }
}));

function SelectionClinic({ polyclinics, handleChangeClinic }) {
    const isMobile = useCheckMobileScreen();
    const { lang } = useContext(LanguageContext);
    const { messages } = useContext(MessagesContext);
    const workspace = useSelector((state) => state?.user?.workspace?.clinic);
    const loadingSelector = createLoadingSelector(type.GET_POLYCLINICS.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const classes = styles({ rtl: lang === 'fa', hasClinic: workspace?.id });

    const dispatch = useDispatch();
    const handleLogOut = () => {
        const refresh = getRefreshToken();
        dispatch(logout({ refresh }));
    };
    return (
        <>
            {isMobile && workspace?.id && <AppBar title={messages.clinic} />}
            <div className="mobileContainer">
                {isLoading ? (
                    <div className="loadingContainer">
                        <CircularProgress color="#063f5e" />
                    </div>
                ) : !polyclinics?.length ? (
                    <div className={classes.noAccessWrapper}>
                        <span data-testid="notAccessClinic">{messages.notAccessClinic}</span>
                        <span className={classes.logout} onClick={handleLogOut}>
                            {messages.logOutFromProfile}
                        </span>
                    </div>
                ) : (
                    <div className={classes.desktopRadio}>
                        <h6 className={classes.clinicHeader}>{messages.selectClinicHeader}</h6>
                        <div className={classes.clinicMessage}>{messages.selectClinicMessage}</div>
                        {polyclinics.map((polyclinic) => (
                            <div className={classes.optionContainer} key={polyclinic.id}>
                                {polyclinic.clinics.map((clinic) => (
                                    <CustomRadio
                                        key={clinic.id}
                                        id={clinic.id}
                                        name={clinic.name}
                                        label={`${clinic.name} - ${polyclinic.name}`}
                                        value={workspace?.name}
                                        handleChange={() => handleChangeClinic(clinic, polyclinic)}
                                    />
                                ))}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}
SelectionClinic.propTypes = {
    polyclinics: PropTypes.array,
    handleChangeClinic: PropTypes.func
};

export default SelectionClinic;
